<template>
    <div class="form form__ruleform">
        <div
            v-if="!rulesIsRoot && rules"
            class="form__ruleform_top"
        >
            <div class="columns is-vcentered">
                <div class="column is-narrow">
                    <div class="form__ruleform_top_title">{{ rulesIndex.length === 1 ? $t('forms.ruleForm.title.rule') : rulesIndex.length === 2 ? $t('forms.ruleForm.title.childRule') : $t('forms.ruleForm.title.grandChildRule') }} {{
                        rulesIndex[rulesIndex.length - 1] + 1 }}
                    </div>
                </div>
                <div class="column"></div>
                <div class="column is-narrow">
                    <div class="form__ruleform_top_remove">
                        <component-button
                            v-if="!disabled"
                            :name="`form-ruleform-remove-${pathRulesIndex}`"
                            :icon="true"
                            :icon-name="'trash-2'"
                            :theme="'default'"
                            @click="openNotifyRemove(rulesIndex)"
                        ></component-button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="rules"
            class="form__ruleform_main"
        >
            <template v-if="rules.expressions.length">
                <template v-if="rulesIsRoot || rules.expressions.length">
                    <div class="form__ruleform_main_rule">
                        <div class="columns is-vcentered is-variable is-1">
                            <div class="column is-narrow">
                                <div class="form__ruleform_main_rule_label form__ruleform_main_rule_label--start">
                                    <component-text :size="'small'">{{ rulesIndex.length === 0 ? $t('forms.ruleForm.text.completeAchievementIf') : $t('forms.ruleForm.text.completeRuleIf') }}</component-text>
                                </div>
                            </div>
                            <div class="column is-narrow custom--center">
                                <form-select
                                    :label="''"
                                    :name="`form-ruleform-rule-${pathRulesIndex}`"
                                    :items="[
                                        {
                                            label: $t('forms.ruleForm.labels.and'),
                                            value: 'AndExpression'
                                        },
                                        {
                                            label: $t('forms.ruleForm.labels.or'),
                                            value: 'OrExpression'
                                        },
                                        {
                                            label: $t('forms.ruleForm.labels.subset'),
                                            value: 'SubsetExpression'
                                        }
                                    ]"
                                    :searchable="false"
                                    :value="rules.rule"
                                    :v-validate="{ required: true }"
                                    :data-vv-as="'rule'"
                                    :disabled="disabled"
                                    @input="emitRulesValue({ indexes: rulesIndex, key: 'rule', value: [...arguments][0] })"
                                />
                            </div>
                            <div class="column is-narrow">
                                <form-number
                                    v-if="rules.rule === 'SubsetExpression'"
                                    :label="''"
                                    :name="`form-ruleform-threshold-${pathRulesIndex}`"
                                    :value="rules.threshold"
                                    :v-validate="{ min_value: 1, max_value: rules.expressions.length }"
                                    :data-vv-as="'threshold'"
                                    :disabled="disabled"
                                    @input="emitRulesValue({ indexes: rulesIndex, key: 'threshold', value: [...arguments][0] })"
                                />
                            </div>
                            <div class="column">
                                <div class="form__ruleform_main_rule_label form__ruleform_main_rule_label--start">
                                    <component-text :size="'small'">{{ rulesIndex.length === 0 ? $t('forms.ruleForm.text.rulesCompleted') : $t('forms.ruleForm.text.conditionsCompleted') }}</component-text>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-for="(ruleNested, ruleNestedChildIndex) in rules.expressions">
                    <div
                        class="form__ruleform_main_box"
                        :key="ruleNestedChildIndex"
                    >
                        <div class="form__ruleform_main_box_middle">
                            <form-ruleform
                                :rules-index="[...rulesIndex, ruleNestedChildIndex]"
                                :rules="ruleNested"
                                :disabled="disabled"
                                @emit-add="emitAdd"
                                @emit-remove="emitRemove"
                                @emit-rules-value="emitRulesValue"
                            />
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div
                    v-if="rules.rule === 'ActivityCompleted'"
                    class="form__ruleform_main_box_middle"
                >
                    <form-select
                        :required="true"
                        :label="$t('forms.ruleForm.labels.completedWhat')"
                        :name="`form-ruleform-type-${pathRulesIndex}`"
                        :items="rulesRuleArray"
                        :value="rules.type"
                        :v-validate="{ required: true }"
                        :data-vv-as="'type'"
                        :disabled="disabled"
                        @input="emitRulesValue({ indexes: rulesIndex, key: 'type', value: [...arguments][0] })"
                    />
                    <form-select
                        v-if="rules.type"
                        :required="true"
                        :label="`${this.$t('forms.ruleForm.labels.nameOf')} ${ toLowerCase(rules.type) || this.$t('forms.ruleForm.labels.item')}`"
                        :name="`form-ruleform-items-${pathRulesIndex}`"
                        :disabled="holdRulesTypeData || !rules.type || disabled"
                        :items="rulesTypeData"
                        :item-name="['item', 'items']"
                        :table-labels="[
                            {
                                key: 'name',
                                title: 'Name',
                                type: 'string',
                                sortable: true,
                                queryable: true
                            },
                            {
                                key: 'status',
                                title: 'Status',
                                type: 'string',
                                sortable: true,
                                queryable: true
                            }
                        ]"
                        :value="rules.id"
                        :v-validate="{ required: rules.type !== '' && rules.id === '' }"
                        :data-vv-as="'items'"
                        :search-queryable="true"
                        :get-pagination-getter="actionHandlers.paginationGetter"
                        :get-items-getter="actionHandlers.itemsGetter"
                        :get-items-getter-mapped="actionHandlers.itemsGetterMapped"
                        :get-items-dispatch="actionHandlers.dispatchAction"
                        @input="emitRulesValue({ indexes: rulesIndex, key: 'id', value: [...arguments][0] })"
                        @input-table="emitRulesValue({ indexes: rulesIndex, key: 'id', value: [...arguments][0] })"
                        @get-items="handleGetItems"
                    />
                </div>
            </template>
        </div>
        <div
            v-if="!disabled"
            class="form__ruleform_bottom"
        >
            <div class="form__ruleform_bottom_add">
                <template v-if="rulesIndex.length > 2">
                    <component-text :size="'small'">{{ $t('forms.ruleForm.text.maximumNumber') }}</component-text>
                </template>
                <template v-else>
                    <component-button
                        :align="'left'"
                        :name="`form-ruleform-add-${pathRulesIndex}`"
                        :theme="'default'"
                        :icon="true"
                        :icon-name="'plus'"
                        @click="emitAdd(rulesIndex)"
                    >{{ $t('forms.ruleForm.title.add') }} {{ rulesIndex.length === 0 ? $t('forms.ruleForm.title.rule') : rulesIndex.length === 1 ? $t('forms.ruleForm.title.childRule') : $t('forms.ruleForm.title.grandChildRule') }}
                    </component-button>
                </template>
            </div>
        </div>
        <pop-notify
            ref="notifyruleremove"
            :class="'form__ruleform_notifyremove'"
            :title-text="$t('forms.ruleForm.notify.titleText')"
            :content-text="$t('forms.ruleForm.notify.contentText')"
            :cancel-button-text="$t('forms.ruleForm.notify.cancelButtonText')"
            :submit-button-text="$t('forms.ruleForm.notify.submitButtonText')"
            :submit-button-danger="true"
            @emit-submit="emitRemove"
        />
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormSelect from '@/components/default/forms/FormSelect'
import FormNumber from '@/components/default/forms/FormNumber'
import ComponentText from '@/components/default/shared/ComponentText'
import PopNotify from '@/components/default/shared/PopNotify'
import { User } from '@/User'

export default {
  name: 'form-ruleform',
  components: { PopNotify, ComponentText, FormNumber, FormSelect, ComponentButton },
  data () {
    return {
      user: new User(),
      rulesTypeData: [],
      holdRulesTypeData: false
    }
  },
  props: {
    rulesIsRoot: {
      type: Boolean,
      default: false
    },
    rules: {
      required: true
    },
    rulesIndex: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    routeParamsId () {
      return this.$route.params.id
    },
    pathRulesIndex () {
      return String(this.rulesIndex).replace(',', '-')
    },
    rulesRuleArray () {
      let arr = [
        {
          label: this.$t('forms.ruleForm.labels.achievement'),
          value: 'Achievement'
        }
      ]
      if (this.user.hasCustomerServices(['LMS'])) {
        arr.push({
          label: this.$t('forms.ruleForm.labels.moduleRule'),
          value: 'Module'
        })
        arr.push({
          label: this.$t('forms.ruleForm.labels.course'),
          value: 'Course'
        })
      }
      if (this.user.hasCustomerServices(['EBS'])) {
        arr.push({
          label: this.$t('forms.ruleForm.labels.event'),
          value: 'Event'
        })
      }
      if (this.user.hasCustomerServices(['DW'])) {
        arr.push({
          label: this.$t('forms.ruleForm.labels.workbook'),
          value: 'Workbook'
        })
      }
      return arr
    },
    rulesType () {
      return this.rules.type
    },
    actionHandlers () {
      let type = this.rulesType
      let dispatchAction
      let paginationGetter
      let itemsGetter
      let itemsGetterMapped
      switch (type) {
        case 'Achievement':
          dispatchAction = 'lmsUserAchievementsGet'
          paginationGetter = 'getLmsUserAchievementsPagination'
          itemsGetter = 'getLmsUserAchievementsMappedIdNameStatus'
          itemsGetterMapped = 'getLmsUserAchievementsMappedLabelValue'
          break
        case 'Event':
          dispatchAction = 'getEvents'
          paginationGetter = 'getEventsPagination'
          itemsGetter = 'getEventsMappedIdNameStatus'
          itemsGetterMapped = 'getEventsMappedLabelValue'
          break
        case 'Course':
          dispatchAction = ''
          paginationGetter = ''
          itemsGetter = ''
          break
        case 'Module':
          dispatchAction = ''
          paginationGetter = ''
          itemsGetter = ''
          break
        case 'Workbook':
          dispatchAction = ''
          paginationGetter = ''
          itemsGetter = ''
          break
      }

      return { dispatchAction, paginationGetter, itemsGetter, itemsGetterMapped }
    }
  },
  watch: {
    rulesType (value) {
      this.performGetRulesTypeData()
    }
  },
  mounted () {
    if (this.rulesType) {
      this.performGetRulesTypeData()
    }
    if (this.disabled) {
      this.$validator.pause()
    }
  },
  methods: {
    openNotifyRemove (data) {
      this.$refs.notifyruleremove.setStoreValue(data)
      this.$refs.notifyruleremove.openNotify()
    },
    emitRemove (data) {
      const value = data || this.$refs.notifyruleremove.storeValue
      this.$emit('emit-remove', value)
    },
    emitAdd (data) {
      const value = data
      this.$emit('emit-add', value)
    },
    emitRulesValue (data) {
      const indexes = data.indexes
      const key = data.key
      const value = data.value
      this.$emit('emit-rules-value', { indexes, key, value })
    },
    performGetRulesTypeData () {
      setTimeout(() => {
        this.$eventBus.$emit(`form-ruleform-items-${this.pathRulesIndex}-trigger-get-items`)
      }, 100)
    },
    handleGetItems (response) {
      let result = response.data.data || response.data
      result = result.filter(item => this.routeParamsId !== item.id)
      result = result.map(item => {
        return {
          label: item.name + item.id,
          customLabel: item.name,
          value: item.id
        }
      })
      this.rulesTypeData = result
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formruleform";
</style>
